import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';

const businesses = [
  {
    title: '作品案例',
    subtitle: '精品漫剧 · 数字内容 · 文旅IP',
    description:
      '汇聚AIGC漫剧、仿真人短剧、文旅宣传片等精品内容，展示从创意到成片的完整工业化能力，覆盖知乎、红果、火山等主流平台。',
    image: 'https://readdy.ai/api/search-image?query=AIGC%20animation%20portfolio%20showcase%2C%20Chinese%20style%20comic%20series%20thumbnails%20displayed%20on%20digital%20screen%2C%20AI%20generated%20characters%20in%20dramatic%20poses%2C%20warm%20golden%20and%20dark%20background%2C%20professional%20content%20studio%20aesthetic%2C%20cinematic%20lighting%2C%20no%20text&width=600&height=400&seq=business-portfolio-01&orientation=landscape',
    highlight: '已推出100部精品AI漫剧，覆盖知乎、红果、火山等平台',
    link: '/case',
  },
  {
    title: '技术实力',
    subtitle: '数字资产库 · AI平台 · 数据系统',
    description:
      '自研AI工业化SOP平台与县域文化数字资产库，覆盖文化资源采集、数字化归档、云端存储、智能生产与多场景复用全流程技术体系。',
    image: 'https://readdy.ai/api/search-image?query=Advanced%20technology%20platform%20interface%20with%20data%20visualization%2C%20digital%20cultural%20heritage%20database%20system%2C%20holographic%20Chinese%20cultural%20elements%2C%20AI%20processing%20pipeline%20visualization%2C%20warm%20gold%20accents%20on%20dark%20background%2C%20futuristic%20tech%20aesthetic%2C%20professional%20corporate%20style%2C%20no%20text&width=600&height=400&seq=business-tech-02&orientation=landscape',
    highlight: '已建成山西117个县域文化数字资产库1.0',
    link: '/technology',
  },
  {
    title: '文化出海',
    subtitle: '海外宣发 · 全球传播 · 文化输出',
    description:
      '将中国传统文化内容通过数字形式推向海外市场，构建全球化文化内容传播矩阵，从IP孵化到全媒体宣发实现文化破圈。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20culture%20going%20global%20concept%2C%20digital%20content%20spreading%20across%20world%20map%2C%20traditional%20Chinese%20elements%20merging%20with%20international%20digital%20platforms%2C%20golden%20light%20streams%20connecting%20continents%2C%20modern%20tech%20aesthetic%2C%20professional%20corporate%20style%2C%20no%20text&width=600&height=400&seq=business-overseas-03&orientation=landscape',
    highlight: '多地县域专属文旅内容矩阵打造',
    link: '/overseas',
  },
  {
    title: '产教融合',
    subtitle: '校企合作 · 人才培养 · 实训基地',
    description:
      '与高校、职业院校共建AIGC内容生产实训基地，培养数字化文旅产业人才，打通产学研链路，构建可持续的人才供给体系。',
    image: 'https://readdy.ai/api/search-image?query=Education%20and%20industry%20integration%20concept%2C%20modern%20vocational%20training%20center%20with%20digital%20technology%2C%20students%20working%20on%20AIGC%20content%20creation%2C%20collaborative%20learning%20space%2C%20warm%20golden%20lighting%2C%20professional%20educational%20environment%2C%20futuristic%20tech%20aesthetic%2C%20no%20text&width=600&height=400&seq=business-education-04&orientation=landscape',
    highlight: '多地校企合作项目落地，打造产教融合新模式',
    link: '/education',
  },
  {
    title: 'OPC超级个体孵化',
    subtitle: 'AI工具 + SOP + 中台 + 实战项目',
    description:
      '依托冯全普·县域AI+OPC联盟，面向返乡青年与创作者打造“一人公司”成长路径，形成人才培养、项目实训、创业孵化、商业变现闭环。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20young%20creators%20using%20AI%20tools%20in%20co-working%20space%2C%20digital%20content%20incubation%20scene%2C%20dark%20background%20with%20warm%20gold%20accents%2C%20professional%20corporate%20style%2C%20no%20text&width=600&height=400&seq=business-opc-05&orientation=landscape',
    highlight: '协同多地OPC社区建设，持续孵化AI超级个体',
    link: '/cooperation',
  },
];

export default function BusinessOverview() {
  return (
    <section className="relative w-full bg-background-950 py-20 md:py-28 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary-500/[0.015] rounded-full blur-3xl pointer-events-none"></div>

      <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
        <div className="max-w-screen-2xl mx-auto">
          <ScrollReveal>
            <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
              <div>
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
                  <span className="w-1 h-1 rounded-full bg-primary-500 animate-pulse"></span>
                  <span className="text-primary-300 text-xs font-medium tracking-wider whitespace-nowrap">
                    五大核心业务
                  </span>
                </div>
                <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50">
                  核心业务
                </h2>
              </div>
              <p className="text-secondary-400 text-base max-w-md leading-relaxed">
                 县域文化数字资产库建设、AIGC漫剧/仿真人短剧定制、城市文旅IP孵化宣发、品牌文化赋能与流量电商运营、OPC超级个体孵化与创作者生态培育。
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {businesses.map((item) => (
              <ScrollReveal key={item.title}>
                <div className="business-card group relative bg-background-900/50 rounded-2xl overflow-hidden border border-primary-500/10 transition-all duration-500 hover:-translate-y-2">
                  {/* Hover glow */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none rounded-2xl"
                    style={{
                      boxShadow: 'inset 0 0 60px rgba(200,160,80,0.06)',
                    }}
                  ></div>

                  <div className="relative h-52 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-900 via-background-900/20 to-transparent"></div>
                    <div className="absolute inset-0 bg-accent-500/0 group-hover:bg-accent-500/5 transition-all duration-500"></div>

                    {/* Image overlay label */}
                    <div className="absolute top-4 left-4 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
                      <span className="px-3 py-1.5 bg-background-950/80 backdrop-blur-sm rounded-full text-white text-xs border border-primary-500/30 whitespace-nowrap">
                        查看详情
                      </span>
                    </div>
                  </div>

                  <div className="p-6 md:p-7 relative">
                    <div className="inline-block px-3 py-1 rounded-full bg-accent-500/15 border border-accent-500/20 text-accent-300 text-xs font-medium mb-4 whitespace-nowrap group-hover:bg-accent-500/20 transition-all duration-300">
                      {item.subtitle}
                    </div>
                    <h3 className="font-heading text-xl font-semibold text-foreground-50 mb-3 group-hover:text-primary-500 transition-colors duration-300">
                      {item.title}
                    </h3>
                    <p className="text-secondary-400 text-sm leading-relaxed mb-5">
                      {item.description}
                    </p>

                    <div className="py-3 px-4 bg-primary-500/5 rounded-lg border border-primary-500/10 mb-5 group-hover:bg-primary-500/8 group-hover:border-primary-500/20 transition-all duration-300">
                      <p className="text-primary-400 text-xs font-medium">{item.highlight}</p>
                    </div>

                    <Link
                      to={item.link}
                      className="group/link inline-flex items-center gap-2 text-primary-500 text-sm font-medium hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      了解详情
                      <span className="w-4 h-4 flex items-center justify-center transition-all duration-300 group-hover/link:translate-x-1">
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
